export const recursiveListTypeOptions = {
  PLAN: 'plan',
  PROJECT: 'project'
}
